import { ArrowRightOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import clsx from "clsx";
import type { OrganizationRequisitesChanges } from "@/features/journal-version-list";
import "./journals-amendments-requisites-diff.scss";

interface JournalsAmendmentsRequisitesDiffProps {
  changes: OrganizationRequisitesChanges;
  compact?: boolean;
}

export const JournalsAmendmentsRequisitesDiff = ({
  changes,
  compact = false,
}: JournalsAmendmentsRequisitesDiffProps) => {
  const requisites = changes.requisites.map((requisite) => ({
    ...requisite,
    change: changes.fields.find((item) => item.field === requisite.field),
  }));

  return (
    <section
      className={clsx(
        "journals-amendments-requisites-diff",
        compact && "journals-amendments-requisites-diff--compact",
      )}
    >
      <div className="journals-amendments-requisites-diff__header">
        <Typography.Title
          level={4}
          className="journals-amendments-requisites-diff__title"
        >
          Изменения в реквизитах
        </Typography.Title>
        <Typography.Text className="journals-amendments-requisites-diff__organization">
          {changes.organizationName}
        </Typography.Text>
        <Typography.Text type="secondary">
          {changes.organizationRole}
        </Typography.Text>
      </div>

      <div className="journals-amendments-requisites-diff__fields">
        {requisites.map((requisite) => (
          <div
            className="journals-amendments-requisites-diff__row"
            key={requisite.field}
          >
            <Typography.Text
              type="secondary"
              className="journals-amendments-requisites-diff__label"
            >
              {requisite.label}
            </Typography.Text>
            {requisite.change ? (
              <div className="journals-amendments-requisites-diff__values">
                <Typography.Text
                  delete
                  className="journals-amendments-requisites-diff__old"
                >
                  {requisite.change.oldValue || "—"}
                </Typography.Text>
                <ArrowRightOutlined />
                <Typography.Text className="journals-amendments-requisites-diff__new">
                  {requisite.change.newValue || "—"}
                </Typography.Text>
              </div>
            ) : (
              <Typography.Text className="journals-amendments-requisites-diff__value">
                {requisite.value || "—"}
              </Typography.Text>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};
